<template>
  <div class="webcam-container">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/fill-details.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988f4">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Duration</td>
            <td class="test-details-right-column">
              {{ $store.getters.getDuration }} hours
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Opens At</td>
            <td class="test-details-right-column">
              {{ $store.getters.getFormattedDate }}
            </td>
          </tr>
        </table>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="recommended">Recommended before you start test</p>
          <p id="recommended-para">
            Before taking {{ $store.state.test.name }}, it is recommended that
            you take a practice test.
          </p>
          <button
            :class="[compatible ? 'practice-test' : 'practice-test-inactive']"
            :disabled="!compatible"
            @click="practiceTest"
          >
            TAKE PRACTICE TEST
          </button>
          <p id="help-support">Help and support</p>
          <p id="contact-administrator">
            You can contact the test administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319bf5"
              >headstart-support@infocusp.com</a
            >
          </p>
          <!--<p id="contact-administrator">
            OR
            <a
              href="https://meet.google.com/kbg-qghf-ody"
              target="_blank"
              style="color: #319BF5"
            >Join this link</a
            >
            to get help on video call
          </p>-->
        </div>
      </div>
    </div>

    <div class="right-pane">
      <div class="inner-white-div">
        <p class="headstart-heading">Welcome to Headstart</p>
        <p class="authentication-heading">Authentication</p>
        <div class="cam-mic-div">
          <div class="cam-mic-box" id="cam-mic-box">
            <video
              v-show="profilePic==='NOT_TAKEN'"
              ref="webcam_feed"
              class="webcam-feed"
              autoplay
            ></video>
            <canvas
              v-show="profilePic==='TAKEN'"
              id="photoTaken"
              ref="canvas"
              :width="493"
              :height="300"
            ></canvas>
            <img
              v-show="profilePic==='EXISTS'"
              v-bind:src="profilePicUrl"
              :width="493"
              :height="300"
            ></img>
          </div>
          <div class="screenshot" v-if="profilePic==='NOT_TAKEN'">
            <p class="capture-photo-heading">
              Capture your photo<br />for further reference
            </p>
            <p class="capture-photo-subheading">
              Position your face in the frame and<br />then click your photo.
            </p>
            <div class="button-group">
              <button type="button" :class="cameraExists?'capture-button':'capture-button-grey'" @click="takePhoto"  :disabled="!cameraExists">
                <img
                  id="capture-image"
                  src="../assets/capture.svg"
                  alt="Capture"
                />
                <p class="capture-button-text">Capture</p>
              </button>
              <button v-if="!uploading && !$store.state.authenticationEnabled" type="button" class="next-button" @click="goToFillDetails">
                  <p class="capture-button-text">Skip</p>
                </button>
            </div>
            <span v-if="!cameraExists" class="camera-mic-dropdown-error"> No Camera was detected in the device</span>
            <div v-if="submitError !== ''" class="submit-error-message">
              <span>{{ submitError }}</span>
            </div>
          </div>

          <div class="screenshot" v-if="profilePic==='TAKEN'">
            <p class="capture-photo-heading">
              Please check your photo<br />before proceeding
            </p>
            <p class="capture-photo-subheading">
              Position your photo in the frame<br />to proceed
            </p>
            <div class="button-group">
              <button v-if="!uploading" type="button" class="next-button" @click="goToFillDetails">
                <p class="capture-button-text">Next</p>
              </button>
              <button v-else type="button" class="uploading-button" disabled @click="goToFillDetails">
                <p class="capture-button-text">Uploading..</p>
              </button>
              <button v-if="!uploading" type="button" :class="profilePicUrl===''?'retake-button-1':'retake-button'" @click="retakePhoto">
                <p :class="profilePicUrl===''?'cancel-button-text':'capture-button-text'">Retake</p>
              </button>
              <button v-if="profilePicUrl!=='' && !uploading" type="button" class="cancel-button" @click="existingPhoto">
                <p class="cancel-button-text">Cancel</p>
              </button>
            </div>
            <div v-if="submitError !== ''" class="submit-error-message">
              <span>{{ submitError }}</span>
            </div>
          </div>

          <div class="screenshot" v-if="profilePic==='EXISTS'">
            <p class="capture-photo-heading">
              Please check your photo<br />before proceeding
            </p>
            <p class="capture-photo-subheading">
              This photo is from your previous test
            </p>
            <div class="button-group">
              <button type="button" class="next-button" @click="goToFillDetails">
                <p class="capture-button-text">Next</p>
              </button>
              <button v-if="cameraExists" type="button" class="retake-button-1" @click="retakePhoto">
                <p class="cancel-button-text">Retake</p>
              </button>
            </div>
            <div v-if="submitError !== ''" class="submit-error-message">
              <span>{{ submitError }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api.service'
export default {
  name: 'Webcam',
  data() {
    return {
      images: {
        camOn: require('../assets/webcam_on_button.svg'),
        camOff: require('../assets/webcam_off_button.svg'),
      },
      compatible: true,
      recorder: null,
      selectedCam: null,
      profilePic: '',
      isShotPhoto: false,
      profilePicUrl: '',
      uploading: false,
      submitError: '',
      cameraExists: true,
      permissionGiven: true,
    }
  },
  async created() {
    if(this.$store.state.currentStep !== 'screenshot') {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$store.commit('setCurrentStep', 'webcam')
      this.$router.replace({ path: `/webcam/test/${testId}/user/${userId}` })
      return;
    }


    let response = await api.checkObjectExists(this.$store.state.test.companyId, this.$route.params.user_id )
    if (response['status'] == 'OK')
    {
      this.profilePic='EXISTS'
      this.profilePicUrl=response['data']
    }
    else
    {
      this.cameraExists = await this.checkMediaDevices()
      this.permissionGiven = await this.getUserPermission()

      this.profilePic='NOT_TAKEN'
      if(this.$store.state.authenticationEnabled === true){
        if(this.cameraExists){
          if(this.permissionGiven == true){
            this.startCameraStream()
          }
          else{
            this.submitError = 'Please give the browser permission to access camera'
          }
        }
        else{
          this.submitError = 'You need to have a camera for authentication'
        }
      }
      else{
        if(this.cameraExists){
          if(this.permissionGiven){
            this.startCameraStream();
          }
        }
      }
    }
  },
  mounted() {
    if(this.$store.state.currentStep !== 'screenshot') {
      return;
    }
  },
  methods: {
    async getUserPermission() {
      const constraints = {
        video: true
      }
      try {
        await navigator.mediaDevices.getUserMedia(constraints).then( (stream) =>{
            let tracks = stream.getTracks()
            tracks.forEach((track) => {
              track.stop()
            })
          })
        this.submitError = ''
        return true
      } catch {
        if(this.$store.state.authenticationEnabled){
          this.submitError = 'Please give the browser permission to access camera'
        }
        return false
      }
    },
     async checkMediaDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      let camFound = devices.some(device => device.kind === "videoinput")
      return camFound
    },
    async goToFillDetails() {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.stopCameraStream()
      this.uploading=true
      if(this.profilePic!=='EXISTS' && this.$store.state.authenticationEnabled == true)
      {
        var emailId = atob(userId)
        const canvas = document
          .getElementById('photoTaken')
          .toDataURL('image/jpeg')
          .replace('data:image/jpeg;base64,', '')

        var details = {
          company_id : this.$store.state.test.companyId,
          email : emailId,
          screenshot : canvas
        }

        var response = await api.postCandidatePhoto(testId, emailId, details)
        if(response['status']=='OK')
        {
          this.stopCameraStream()
          this.$store.commit('setCurrentStep', 'fill-details')
          this.$router.replace({ path: `/fill-details/test/${testId}/user/${userId}` })
        }
        else
        {
          this.uploading=false
          console.log("photo was not uploaded")
          this.submitError = 'Unable to upload photo, please try again'
        }
      }
      else
      {
        if(this.profilePic == 'TAKEN'){
          var emailId = atob(userId)
          const canvas = document
            .getElementById('photoTaken')
            .toDataURL('image/jpeg')
            .replace('data:image/jpeg;base64,', '')

          var details = {
            company_id : this.$store.state.test.companyId,
            email : emailId,
            screenshot : canvas
          }

          var response = await api.postCandidatePhoto(testId, emailId, details)
          if(response['status']!=='OK')
          {
            this.uploading=false
            console.log("photo was not uploaded")
          }
        }
        this.$store.commit('setCurrentStep', 'fill-details')
        this.$router.replace({ path: `/fill-details/test/${testId}/user/${userId}` })
      }

    },
    practiceTest() {
      window.open('https://headstart.infocusp.com/#/practice-test', '_blank')
    },
    startCameraStream() {
      const constraints = {
        video: true
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.webcam_feed.srcObject = stream
        })
        .catch((error) => {
          alert("Browser doesn't support or there is some errors." + error)
        })
    },
    stopCameraStream() {
      if(this.$refs.webcam_feed.srcObject !== null){
        let tracks = this.$refs.webcam_feed.srcObject.getTracks()
        tracks.forEach((track) => {
          track.stop()
        })
      }
    },
    async takePhoto() {
      if(await this.checkMediaDevices() == true){
        if(await this.getUserPermission()){
          if (this.profilePic==='NOT_TAKEN') {
            this.isShotPhoto = true

            const FLASH_TIMEOUT = 50

            setTimeout(() => {
              this.isShotPhoto = false
            }, FLASH_TIMEOUT)
          }

          this.profilePic = 'TAKEN'

          const context = this.$refs.canvas.getContext('2d')
          context.drawImage(this.$refs.webcam_feed, 0, 0, 493, 300)
          this.stopCameraStream()
          // console.log(context)
          // console.log(typeof(context))
        }
        else{
          this.submitError = 'Please give the browser permission to access camera'
        }
      }
      else{
        this.submitError = 'You need to have a camera for authentication'
      }
    },
    async retakePhoto() {
      if(await this.checkMediaDevices() == true){
        if(await this.getUserPermission()){
          this.profilePic = 'NOT_TAKEN'
          this.startCameraStream()
        }
        else{
          this.submitError = 'Please give the browser permission to access camera'
        }
      }
      else{
        this.submitError = 'You need to have a camera to retake photo'
      }
    },
    existingPhoto() {
      this.profilePic = 'EXISTS'
    },
    downloadImage() {
      const download = document.getElementById('photoTaken')
      const canvas = document
        .getElementById('photoTaken')
        .toDataURL('image/jpeg')
        .replace('data:image/jpeg;base64,', '')
      download.setAttribute('href', canvas)
    },
  },
}
</script>

<style>
.buttons-div {
  position: relative;
}

.cam-mic-box {
  width: 493px;
  height: 300px;
  background: black;
  color: white;
  text-align: center;
}

.cam-mic-buttons-div {
  display: flex;
  position: absolute;
  top: -155px;
  margin-top: 20%;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
}

.cam-mic-buttons-div img {
  cursor: pointer;
}

.cam-mic-div {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
}

.cam-mic-status {
  /* margin-left: 38%; */
  position: absolute;
  top: -165px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
}

.choose-device {
  display: inline-block;
  margin-bottom: 24px;
}

.choose-mic-cam {
  margin-left: 38px;
  /* display: flex; */
}

#contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

.disabled-webcam-feed {
  display: none;
}

.headstart-heading {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 56px;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 32px;
}

.help-section {
  margin-top: auto;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

.hidden-element {
  display: none;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #f2f2f2;
  padding-left: 18px;
  margin-right: 30px;
}

#image {
  display: block;
  margin: 24px auto;
  height: 200px;
  width: 216px;
}

.inner-white-div {
  flex: 1;
  padding: 40px;
  /*background: #ffffff;*/
  border-radius: 2px;
}

#left-pane {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #ffffff;
  /*box-shadow: inset -1px 0 0 0 #a8b2c6;*/
  height: 100%;
  max-width: 376px;
  border-right: 1px solid #b5b8b8;
}

.mic-button {
  margin-right: 5%;
}

.overlay-div {
  z-index: 10;
  position: absolute;
  top: 54%;
  left: 37%;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 346px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.practice-test {
  border: 1px solid #1bc09c;
  border-radius: 2px;
  background-color: white;
  color: #1bc09c;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

.practice-test:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #f2f2f2;
  outline: #1bc09c;
  cursor: pointer;
}

.practice-test:active {
  background: #1bc09c;
  border: 1px solid #1bc09c;
  color: white;
  outline: #1bc09c;
}

.practice-test-inactive {
  background: #eeeeee;
  border: 1px solid rgba(155, 155, 155, 0.2);
  color: #9b9b9b;
  padding: 4px;
  border-radius: 2px;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

#recommended {
  color: #616262;
}

#recommended-para {
  margin-top: 8px;
  color: #9b9b9b;
  line-height: 20px;
  font-family: Roboto-Regular;
}

.right-pane {
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  overflow-x: hidden;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

.select-input-field {
  width: 297px;
  height: 36px;
  padding: 0 10px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  -webkit-appearance: menulist;
}

.status-div {
  position: relative;
}

.submit-btn {
  background: #526aff;
  color: white;
  border-radius: 4px;
  padding: 10px 16px;
}

.download-btn {
  background: #526aff;
  color: white;
  border-radius: 4px;
  padding: 10px 16px;
  width: 110px;
  height: 37px;
}

.system-compatible {
  width: fit-content;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-left: 32px;
  min-height: 30px;
}

.system-compatible-green {
  background: rgba(99, 219, 193, 0.1);
  color: #1bc09c;
}

.system-compatible-msg {
  margin: 8px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: 0;
}

.system-compatible-red {
  background: rgba(246, 105, 87, 0.1);
  color: #f66957;
}

.screenshot {
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  margin-top: 31px;
}

.capture-photo-heading {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;

  color: #000000;
}

.capture-photo-subheading {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}

.capture-button {
  width: 105px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #526aff;
  border-radius: 4px;
  margin-top: 8px;
  margin-right: 8px;
}

.capture-button-grey {
  width: 105px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #909ffc;
  border-radius: 4px;
  margin-top: 8px;
  margin-right: 8px;
}

.next-button {
  width: 63px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #526aff;
  border-radius: 4px;
  margin-top: 8px;
}

.next-button-grey {
  width: 63px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #909ffc;
  border-radius: 4px;
  margin-top: 8px;
}

.retake-button {
  width: 75px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #526aff;
  border-radius: 4px;
  margin-top: 8px;
  margin-left: 8px;
}

.retake-button-1 {
  width: 75px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #e7e7e7;
  border-radius: 4px;
  margin-top: 8px;
  margin-left: 8px;
}

.cancel-button {
  width: 75px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #e7e7e7;
  border-radius: 4px;
  margin-top: 8px;
  margin-left: 8px;
}

.uploading-button {
  width: 100px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #909ffc;
  border-radius: 4px;
  margin-top: 8px;
}

.capture-button-text {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin: 7px;
  color: #ffffff;
}

.cancel-button-text {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin: 7px;
  color: #000000;
}

.button-group {
  display: flex;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.underlay-div {
  z-index: 0;
}

.webcam-container {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

.webcam-feed {
  width: inherit;
  height: inherit;
}

.webcam-heading {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 24px;
}

.web-camera-container .camera-shoot {
  margin: 1rem 0;
}
.web-camera-container .camera-shoot button {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.web-camera-container .camera-shoot button img {
  height: 35px;
  object-fit: cover;
}

.submit-error-message {
  width: fit-content;
  margin-top: 24px;
  padding: 9px;
  background-color: #fff6f6;
  color: #9f3a38;
  border: 1px solid #9f3a38;
  border-radius: 5px;
}

.authentication-heading {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 24px;
}

.camera-mic-dropdown-error {
  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  color: red;
}

</style>
